<div class="container">
  <div *ngIf="isCreateLoading" class="loading-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <h1 class="page-title">
    <span class="icon"><em class="fas fa-truck-moving"></em></span>{{ "PurchaseOrder.CreateAd.Header" | translate }}
  </h1>

  <p-card>
    <div class="p-fluid grid">
      <form [formGroup]="createDocForm"
        class="field col-12 md:col-4 lg:col-3">
        <!--Choose Create DocType-->
          <p class="mt-0 mb-2">
          {{ "PurchaseOrder.CreateAd.ChooseCreateDocNo" | translate }}
        </p>
        <p-dropdown
          [options]="createDocOptions"
          [filter]="true"
          [(ngModel)]="createDoc"
          formControlName="createDoc"
          (onChange)="chooseCreateDoc()"
        ></p-dropdown>
      </form>
      <!--Create AD Header-->
      <form
        [formGroup]="createAdHeaderForm"
        class="field col-12 md:col-8 lg:col-9"
      >
        <div class="p-fluid grid">
          <div class="field col-12 md:col-6 lg:col-3 mb-3">
            <p class="mt-0 mb-2">
              {{ "PurchaseOrder.CreateAd.HeaderForm.BillOfLading" | translate }}
            </p>
            <input type="text" pInputText formControlName="billOfLading" />
          </div>
          <div class="field col-12 md:col-6 lg:col-3 mb-3">
            <p class="mt-0 mb-2" [style.color]="customerImportNoTextColor">
              {{
                "PurchaseOrder.CreateAd.HeaderForm.CustomerImportNo" | translate
              }}
            </p>
            <input type="text" pInputText formControlName="customerImportNo" />
            <small
              *ngIf="
                createAdHeaderForm.get('customerImportNo')?.errors &&
                createAdHeaderForm.get('customerImportNo')?.errors?.maxlength
              "
              class="alert"
            >
              <div class="p-invalid">
                {{
                  "PurchaseOrder.CreateAd.Message.ImportNoOversize" | translate
                }}
              </div>
            </small>
          </div>
          <div class="field col-12 md:col-6 lg:col-3">
            <p class="mt-0 mb-2">
              {{ "PurchaseOrder.CreateAd.HeaderForm.IsUrgent" | translate }}
            </p>
            <p-checkbox formControlName="priority" [binary]="true"></p-checkbox>
          </div>
          <div class="field col-12 md:col-6 lg:col-3 mb-3">
            <p class="mt-0 mb-2">
              <label><span class="requiredStart">*</span>{{ 'PurchaseOrder.CreateAd.HeaderForm.InbondedFlag' | translate }}</label>
            </p>
            <div class="grid">
              <div class="field col-12 md:col-12 lg:col-6 pt-4">
                <p-radioButton
                  formControlName="inbondedFlag"
                  name="inbondedFlag"
                  value="InBonded"
                  label="{{'PurchaseOrder.CreateAd.HeaderForm.InBonded' | translate}}"
                ></p-radioButton>
              </div>
              <div class="field col-12 md:col-12 lg:col-6 pt-4">
                <p-radioButton
                  formControlName="inbondedFlag"
                  name="inbondedFlag"
                  value="NonBonded"
                  label="{{'PurchaseOrder.CreateAd.HeaderForm.NonBonded' | translate}}"
                ></p-radioButton>
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-6 lg:col-3 mb-3">
            <p class="mt-0 mb-2">
              <label><span class="requiredStart">*</span>{{ 'PurchaseOrder.CreateAd.HeaderForm.DeliveryMode' | translate }}</label>
            </p>
            <p-dropdown
              [filter]="true"
              placeholder="{{ 'Common.DropDown.Select' | translate }}"
              [options]="shipMethodOptions"
              formControlName="shippingMethod"
            ></p-dropdown>
            <div *ngIf="((submitted || createAdHeaderForm.controls.shippingMethod.touched) &&  createAdHeaderForm?.controls?.shippingMethod?.errors?.required)" >
              <small class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
            </div>
          </div>

          <div class="field col-12 md:col-6 lg:col-3 mb-3">
            <p class="mt-0 mb-2" [style.color]="textColor">
              {{ "PurchaseOrder.CreateAd.HeaderForm.DeclType" | translate }}
            </p>
            <p-dropdown
              [filter]="true"
              placeholder="{{ 'Common.DropDown.Select' | translate }}"
              [options]="declTypeOptions"
              formControlName="declType"
            ></p-dropdown>
          </div>

          <div class="field col-12 md:col-6 lg:col-3 mb-3">
            <p class="mt-0 mb-2" [style.color]="textColor">
              {{ "PurchaseOrder.CreateAd.HeaderForm.GdsType" | translate }}
            </p>
            <div class="grid">
              <div class="field col-12 md:col-12 lg:col-6 pt-4">
                <p-radioButton
                  formControlName="gdsType"
                  name="gdsType"
                  value="aTransaction"
                  label="{{
                    'PurchaseOrder.CreateAd.HeaderForm.ATransaction' | translate
                  }}"
                ></p-radioButton>
              </div>
              <div class="field col-12 md:col-12 lg:col-6 pt-4">
                <p-radioButton
                  formControlName="gdsType"
                  name="gdsType"
                  value="monthly"
                  label="{{
                    'PurchaseOrder.CreateAd.HeaderForm.Monthly' | translate
                  }}"
                ></p-radioButton>
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-6 lg:col-3 mb-3">
            <p class="mt-0 mb-2">
              {{ "PurchaseOrder.CreateAd.HeaderForm.RefBillNo" | translate }}
            </p>
            <input type="text" pInputText formControlName="refBillNo" />
          </div>
        </div>
      </form>
    </div>
    <div class="p-fluid grid">
      <div class="field col-12 md:col-6 lg:col-3 mb-3">
        <h3 class="font-bold mt-0 mb-2">
          {{ "PurchaseOrder.CreateAd.InputDefaultOpenQty" | translate }}
        </h3>
        <p-checkbox
          [(ngModel)]="isInputDefaultOpenQty"
          [binary]="true"
          (ngModelChange)="inputDefaultOpenQty()"
        ></p-checkbox>
      </div>
    </div>
    <!--Create AD Detail -->
    <div class="mt-2">
      <laas-data-table
        #createAdTable
        [defaultColumns]="detailColumns"
        [loading]="isDetailLoading"
        [value]="detailDatas"
        [editPermission]="editPermissionCode"
        [isShowCreateRowFunction]="false"
        [isShowSaveFunction]="false"
        [tableKey]="preferenceKey"
        dataKey="seqNo"
      >
        <ng-template pTemplate="caption" ngIf="editPermission">
          <button
            pButton
            pRipple
            label="{{ 'PurchaseOrder.DetailColumn.InputItemNo' | translate }}"
            (click)="InputItemNo()"
            class="ml-2 p-button-secondary"
          ></button>
          <button
            pButton
            pRipple
            label="Create AD"
            (click)="createAd()"
            class="ml-2"
          ></button>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr [ngClass]="{ 'disabled-row': !(rowData | detailIssuable) }">
            <td *ngFor="let col of columns">
              <ng-container [ngSwitch]="col.field">
                <ng-container *ngSwitchCase="'__delete'"> - </ng-container>
                <ng-container *ngSwitchCase="'autoAdvisingFlag'">
                  {{
                    (rowData[col.field] === 'Y'
                      ? 'AsnDn.DetailColumn.AutoAdvisingYes'
                      : 'AsnDn.DetailColumn.AutoAdvisingNo') | translate
                  }}
                </ng-container>
                <ng-container *ngSwitchCase="'stsFlag'" class="p-fluid">
                  {{ rowData[col.field] | stsFlagMapping }}
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <div [ngSwitch]="col.dataType" class="overflow-text">
                    <ng-container *ngSwitchCase="'date'">
                      {{
                        rowData[col.field]
                          | date : "yyyy-MM-dd HH:mm:ss"
                          | replaceNullWith : "-"
                      }}
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      {{ rowData[col.field] | replaceNullWith : "-" }}
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </td>
          </tr>
        </ng-template>

        <!--Input-->
        <ng-template pTemplate="bodyInputTemplate" let-rowData let-col="col">
          <div [ngClass]="{ 'disabled-row': !(rowData | detailIssuable) }">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'__Function'">
                <span
                  class="icon"
                  (click)="copyBtnClick($event, rowData)"
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  pTooltip="{{
                    'PurchaseOrder.DetailColumn.CopyRow' | translate
                  }}"
                >
                  <i class="far fa-copy" *ngIf="(rowData | detailIssuable)"></i>
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="'location'" class="p-fluid">
                <span *ngIf="!(rowData | detailIssuable)">{{
                  rowData[col.field]
                }}</span>
                <input
                  *ngIf="(rowData | detailIssuable)"
                  type="text"
                  pInputText
                  [(ngModel)]="rowData[col.field]"
                  appendTo="body"
                  class="p-fluid"
                />
              </ng-container>
              <ng-container *ngSwitchCase="'openQty'" class="p-fluid">
                <span *ngIf="!(rowData | detailIssuable)">{{
                  rowData[col.field]
                }}</span>
                <input
                  *ngIf="(rowData | detailIssuable)"
                  type="number"
                  pInputText
                  [(ngModel)]="rowData[col.field]"
                  appendTo="body"
                  class="p-fluid"
                />
                <small
                  *ngIf="!checkNumberInteger(rowData[col.field])"
                  class="alert"
                >
                  <div class="p-invalid">
                    {{
                      "PurchaseOrder.CreateAd.Message.EnterInterger" | translate
                    }}
                  </div>
                </small>
              </ng-container>
              <ng-container *ngSwitchCase="'itemNo'" class="p-fluid">
                <span *ngIf="!(rowData | detailIssuable)">{{
                  rowData[col.field]
                }}</span>
                <input
                  *ngIf="(rowData | detailIssuable)"
                  type="text"
                  pInputText
                  [(ngModel)]="rowData[col.field]"
                  appendTo="body"
                  class="p-fluid"
                />
              </ng-container>
              <ng-container *ngSwitchCase="'coo'" class="p-fluid">
                <span *ngIf="!(rowData | detailIssuable)">{{
                  rowData[col.field]
                }}</span>
                <p-dropdown
                  *ngIf="(rowData | detailIssuable)"
                  [filter]="true"
                  placeholder="{{ 'Common.DropDown.Select' | translate }}"
                  [options]="countryOptions"
                  [showClear]="true"
                  appendTo="body"
                  [itemSize]="30"
                  [virtualScroll]="true"
                  [(ngModel)]="rowData[col.field]"
                  class="p-fluid"
                ></p-dropdown>
              </ng-container>
              <ng-container *ngSwitchCase="'createDt'" class="p-fluid">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date : "yyyy-MM-dd HH:mm:ss"
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'__delete'">
                <i class="pi pi-trash ml-2 mt-2" (click)="deleteBtnClick(rowData.seqNo)"></i>
              </ng-container>
              <ng-container *ngSwitchCase="'stsFlag'" class="p-fluid">
                {{ rowData[col.field] | stsFlagMapping }}
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div [ngSwitch]="col.dataType" class="overflow-text">
                  <ng-container *ngSwitchCase="'date'" class="p-fluid">
                    {{
                      rowData[col.field]
                        | date : "yyyy-MM-dd HH:mm:ss"
                        | replaceNullWith : "-"
                    }}
                  </ng-container>
                  <ng-container *ngSwitchDefault class="p-fluid">
                    {{ rowData[col.field] | replaceNullWith : "-" }}
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </ng-template>

        <!--Output-->
        <ng-template pTemplate="bodyOutputTemplate" let-rowData let-col="col">
          <div [ngClass]="{ 'disabled-row': !(rowData | detailIssuable) }">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'__Function'">
                <span
                  class="icon"
                  (click)="copyBtnClick($event, rowData)"
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  pTooltip="{{
                    'PurchaseOrder.DetailColumn.CopyRow' | translate
                  }}"
                >
                  <i class="far fa-copy" *ngIf="(rowData | detailIssuable)"></i>
                </span>
              </ng-container>

              <ng-container *ngSwitchCase="'openQty'" class="p-fluid">
                <div class="overflow-text">
                  {{ rowData[col.field] | replaceNullWith : "-" }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'itemNo'" class="p-fluid">
                <div class="overflow-text">
                  {{ rowData[col.field] | replaceNullWith : "-" }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'coo'" class="p-fluid">
                <div class="overflow-text">
                  {{ rowData[col.field] | replaceNullWith : "-" }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'createDt'" class="p-fluid">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date : "yyyy-MM-dd HH:mm:ss"
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'__delete'">
                <i class="pi pi-trash ml-2 mt-2" (click)="deleteBtnClick(rowData.seqNo)"></i>
              </ng-container>

              <ng-container *ngSwitchCase="'stsFlag'" class="p-fluid">
                {{ rowData[col.field] | stsFlagMapping }}
              </ng-container>

              <ng-container *ngSwitchDefault>
                <div [ngSwitch]="col.dataType" class="overflow-text">
                  <ng-container *ngSwitchCase="'date'" class="p-fluid">
                    {{
                      rowData[col.field]
                        | date : "yyyy-MM-dd HH:mm:ss"
                        | replaceNullWith : "-"
                    }}
                  </ng-container>
                  <ng-container *ngSwitchDefault class="p-fluid">
                    {{ rowData[col.field] | replaceNullWith : "-" }}
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
</div>

<p-dialog
  p-dialog
  header="Create AD success!"
  appendTo="body"
  [(visible)]="isShowSuccessfulAdNo"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{ width: '25%' }"
  max-height="500"
>
  <div class="p-fluid formgrid grid">
    <div class="field col-12">
      <label>AdNo : {{ successfulAdNo }}</label>
    </div>
  </div>
</p-dialog>
